export default class QueryWhereStatus
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryWhereStatus";

	static Open = "Open";
	static Lock = "Lock";
	static Hide = "Hide";
		
	static OPENLABEL = "Open";
	static LOCKLABEL = "Lock";
	static HIDELABEL = "Hide";
		
	static valueOf(value)
	{
		if(value == QueryWhereStatus.OPENLABEL || value == "")
			return QueryWhereStatus.Open;
		else if(value == QueryWhereStatus.LOCKLABEL)
			return QueryWhereStatus.Lock;
		else if(value == QueryWhereStatus.HIDELABEL)
			return QueryWhereStatus.Hide;
				
		throw new Error("错误的枚举类型");
	}
	
	static getLabel(value)
	{
		if(value == QueryWhereStatus.Open)
			return QueryWhereStatus.OPENLABEL;
		else if(value == QueryWhereStatus.Lock)
			return QueryWhereStatus.LOCKLABEL;
		else if(value == QueryWhereStatus.Hide)
			return QueryWhereStatus.HIDELABEL;
		
		throw new Error("错误的枚举类型");
	}
	
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryWhereStatus.js